/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	17-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_interactions_init = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	/**
	None yet
	**/
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	this.onready = function() {
		
		/**
		Unbind: Unnecessary listeners
		**/
		//$(document).off('click.cookieWallSubmit');
		//$(document).off('click.cookieWallTabs');
		//$(document).off('click.cookieBarSubmit');
		
		/*
		Close the mobilemenu always on route
		*/
		specific_mobilemenu.toggle(1);

		/*
		Trigger: Instagram
		*/
		//specific_instagram.onready('thumb',8,true);

		/*
		Trigger: Facebook
		*/
		//specific_facebook.onready(6,true);
		
		specific_calculator.onready();
		specific_faq.onready();
		specific_whatweknow.onready();
		specific_cookies.onready();

		if($('.js-explainer-video').length == 1) {
			specific_explainer.onready();
		}

		/*
		Celebrus: ReInit()
		*/
		celebrusdoReInit();

		/*
		Remove Triggered
		*/
		$('.js-scrollinview').removeClass('triggered');

		/*
		Popup: Open on load
		*/
		if(url[1] == 'afspraak-maken') {
			popup.open(1,1,'afspraakmaken');
		}

		if(url[1] == 'contact') {
			$('footer').hide();
		} else {
			$('footer').show();
		}

		/*
		Tippy
		*/
		tippy('.js-explainer-item-tooltip', {
			content: 'Global content',
			allowHTML: true,
			theme: 'onmarc'
		});

		/*
		Catch and active URL
		*/
		var _url_active_main = './';
		
		$('.js-nav-item').removeClass('active');

		if(url[1] !== '') { 
			_url_active_main = url[1];
		}

		if(url[2] !== '') {
			_url_active_main = url[1] + '/' + url[2];
		}
		
		if(_url_active_main !== '') {
			$('.js-nav-item[data-go-url="' + _url_active_main + '"]').addClass('active');
		}		

		/*
		Slideshow: Highlights
		*/
		var slideshow = new Swiper('.js-highlights-swiper', {
			navigation: {
			    nextEl: '.button-next',
			    prevEl: '.button-prev',
			  },
			loop:true,
			
			slidesPerView: 3,

			breakpoints: {
				1000: {
				  slidesPerView: 1,
				  spaceBetween: 20
				},
				320: {
				  slidesPerView: 1,
				  spaceBetween: 20
				}
			}

		});

	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	// none
	
}).apply(specific_interactions_init); 
